document.addEventListener('DOMContentLoaded', () => {
  const swiperElement = document.querySelector('.js-step-swiper')
  const swiperNavigation = document.querySelector('.js-step-swiper .swiper-pagination')
  const swiperPrevArrow = document.querySelector('.js-step-swiper .swiper-button-prev')
  const swiperNextArrow = document.querySelector('.js-step-swiper .swiper-button-next')

  if (swiperElement) {
    new Swiper(swiperElement, {
      slidesPerView: 1.3,
      spaceBetween: 21,
      navigation: {
        nextEl: swiperNextArrow,
        prevEl: swiperPrevArrow,
      },
      pagination: {
        el: swiperNavigation,
      },
      breakpoints: {
        576: {
          spaceBetween: 21,
          slidesPerView: 2.3
        },
        768: {
          spaceBetween: 21,
          slidesPerView: 3
        },
        1024: {
          spaceBetween: 21,
          slidesPerView: 4
        }
      }
    })
  }
})
